<div fxLayout="row wrap" *ngIf="userService.user">
  <div class="home-button" fxFlex="25" *ngFor="let action of userService.menuRoutes">
    <a mat-raised-button routerLinkActive="active mat-primary" routerLink="{{action.url}}">{{action.routeName | uppercase}}</a>
  </div>
</div>
